import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { APP_ROUTES } from '../../constants/routes.const';
import { CommonModule } from '@angular/common';
import { NavItem } from './models/NavItem.model';

@Component({
  selector: 'app-navigation',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, ButtonModule],
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.scss',
})
export default class NavigationComponent {
  @Input() open = true;
  @Output() toggled = new EventEmitter<void>();

  readonly R = APP_ROUTES;

  readonly items: NavItem[] = [
    { label: 'Dashboard', icon: 'pi pi-home', link: `/${this.R.DASHBOARD}`, exact: true },
    { label: 'Ofertas', icon: 'pi pi-briefcase', link: `/${this.R.OFERTAS.BASE}` },
  ];

  toggle() {
    this.toggled.emit();
  }
}
